// extracted by mini-css-extract-plugin
export default {"categoryLink":"Filter_categoryLink__CJUuk"};